import React from 'react'

const TrashCanIcon = () => {
	return (
		<svg width={19} height={24} viewBox='0 0 19 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0)' fill='currentColor'>
				<path d='M2.231 23.04c.299.306.653.547 1.043.712.39.165.808.249 1.23.248h.01l9.994-.033a3.193 3.193 0 002.268-.968c.601-.616.94-1.45.941-2.318V6.545h.72a.56.56 0 00.4-.17.583.583 0 00.165-.407V3.227c0-.153-.06-.3-.166-.408a.56.56 0 00-.4-.17h-5.088V.578c0-.153-.06-.3-.166-.408a.56.56 0 00-.4-.169H6.225a.56.56 0 00-.4.169.583.583 0 00-.166.408v2.074H.57a.56.56 0 00-.4.17.583.583 0 00-.165.407V5.97c0 .153.06.3.165.408a.56.56 0 00.4.169h.718v14.165c-.001.433.08.862.243 1.262.162.4.4.762.7 1.068zm14.357-2.36a2.16 2.16 0 01-.609 1.508c-.39.4-.92.628-1.474.63l-9.994.034h-.007a2.068 2.068 0 01-1.476-.625 2.154 2.154 0 01-.612-1.507V6.549h14.172V20.68zM6.79 1.155h5.424v1.497H6.79V1.154zM1.136 3.805H17.87v1.587H1.131l.005-1.587z' />
				<path d='M9.5 19.03a.56.56 0 00.4-.17.583.583 0 00.166-.408v-8.74c0-.153-.06-.3-.165-.408a.56.56 0 00-.8 0 .583.583 0 00-.166.408v8.74c0 .153.06.3.166.408a.56.56 0 00.4.17zM6.084 19.03a.56.56 0 00.4-.17.583.583 0 00.165-.408v-8.74c0-.153-.06-.3-.165-.408a.56.56 0 00-.8 0 .583.583 0 00-.165.408v8.74c0 .153.06.3.165.408a.56.56 0 00.4.17zM12.918 19.03a.56.56 0 00.4-.17.583.583 0 00.165-.408v-8.74c0-.153-.06-.3-.166-.408a.56.56 0 00-.8 0 .583.583 0 00-.165.408v8.74c0 .153.06.3.166.408a.56.56 0 00.4.17z' />
			</g>
			<defs>
				<clipPath id='clip0'>
					<path fill='currentColor' d='M0 0H19V24H0z' />
				</clipPath>
			</defs>
		</svg>
	)
}

export default TrashCanIcon
